var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 0L18.1325 0.77341L1.83107 7.41472L0.000488281 8.15009L1.79364 8.96154L8.15119 11.8487L11.0377 18.2068L11.8492 20L12.5846 18.1694L19.2259 1.86802L19.9999 0ZM16.925 3.07493L11.7743 15.6976L9.56699 10.8483L9.43477 10.5651L9.15161 10.4329L4.30225 8.22556L16.925 3.07493Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6833 4.34226L8.85256 10.3191L9.7064 11.173L15.6833 4.34226Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.979ca0f991593c04cd19303eab45aace.svg";
export { ForwardRef as ReactComponent };